import { render, staticRenderFns } from "./EditTipotelefonePage.vue?vue&type=template&id=6125b4bc"
import script from "./EditTipotelefonePage.vue?vue&type=script&lang=js"
export * from "./EditTipotelefonePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports